module.exports = __webpack_public_path__ + "static/acton_before-ae5cb4f86fb3073697eaf9a100bd5153.png";